import styled from 'styled-components';

export const Overlay = styled.div({
  position: 'fixed',
  width: '100%',
  height: '100%',
  zIndex: 16000,
  left: 0,
  top: 0,
  background: 'rgba(255, 255, 255, 0.2)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});
